import { createFileRoute } from '@tanstack/react-router'

import { exportReportDocument } from '@/components/report-viewer/export'
import { PositionReport } from '@/components/reports/positions/position-report'
import { validatePositionReportSearch } from '@/components/reports/positions/position-report-search'
import { ReportPage } from '@/components/reports/report-page'
import { useAuth } from '@/hooks/use-auth'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/reports/positions',
)({
    validateSearch: validatePositionReportSearch,
    component: PositionReportPage,
})

function PositionReportPage() {
    const search = Route.useSearch()
    const navigate = Route.useNavigate()
    const { hasPermission } = useAuth()
    return (
        <ReportPage title={m.position_report_page_title()}>
            <PositionReport
                search={search}
                onSearchChange={(next) =>
                    void navigate({
                        search: (prev) => ({ ...prev, ...next }),
                        replace: true,
                    })
                }
                exportDocument={
                    hasPermission('reports.export')
                        ? exportReportDocument
                        : undefined
                }
            />
        </ReportPage>
    )
}
